import { render, staticRenderFns } from "./sms-verification.vue?vue&type=template&id=1dfc23ae&scoped=true"
import script from "./sms-verification.vue?vue&type=script&lang=js"
export * from "./sms-verification.vue?vue&type=script&lang=js"
import style0 from "./sms-verification.vue?vue&type=style&index=0&id=1dfc23ae&prod&lang=css"
import style1 from "./sms-verification.vue?vue&type=style&index=1&id=1dfc23ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc23ae",
  null
  
)

export default component.exports